import React from 'react';

export default function Demarche({ navigate }) {
  return (
    <article className="demarche-page">
      <header className="demarche-hero">
        <div className="demarche-hero-overlay">
          <p className="demarche-eyebrow">Notre démarche</p>
          <h1 className="demarche-title">L’eau, première urgence</h1>
          <p className="demarche-lede">
            Comprendre le terrain, agir vite, transmettre la responsabilité aux villages.
          </p>
        </div>
      </header>

      <section className="demarche-section">
        <div className="demarche-inner">
          <h2 className="demarche-h2">Le contexte</h2>

          <p>
            Dans les territoires situés au nord du 8<sup>ème</sup> parallèle, au Ghana, au Togo,
            au Bénin ou au Nigéria, l’eau est la plupart du temps puisée par les femmes et les
            enfants, parfois très loin du village, soit dans les rivières et fleuves, soit dans
            les marigots. La plupart du temps, les enfants manquent l’école pour chercher l’eau.
          </p>

          <p>
            Dans les régions plus au nord encore, au Niger, au Burkina Faso ou au Mali, outre le
            fleuve Niger et quelques petits affluents, c’est principalement par l’eau de puits et
            de forage que peuvent être approvisionnés les habitants de la brousse.
          </p>

          <p>
            On comprend facilement que l’eau tirée de la nappe phréatique présente des conditions
            de salubrité bien plus sûres que celle puisée en surface&nbsp;: l’eau des rivières et
            fleuves, et davantage encore celle qui croupit dans les marais, apporte toutes sortes
            de maladies allant de l’onchocercose au ver de Guinée, aux amibiases, au choléra, etc.
            (outre les maladies comme le paludisme et la trypanosomiase, dues au moustique et à la
            mouche tsé-tsé qui sévissent aux abords des eaux de surface).
          </p>

          <h2 className="demarche-h2">Notre principe</h2>

          <p className="demarche-intro">
            Notre principe étant d’essayer de répondre à des urgences, sans perdre ni temps ni
            argent, nous réalisons ou réparons des puits et des forages de la manière suivante&nbsp;:
          </p>

          <ol className="demarche-steps">
            <li>
              <span className="demarche-step-num">1</span>
              <div>
                <h3>Visite du village demandeur</h3>
                <p>Aller sur place, rencontrer les habitants, évaluer la situation.</p>
              </div>
            </li>
            <li>
              <span className="demarche-step-num">2</span>
              <div>
                <h3>Recherche de l’eau</h3>
                <p>Identifier le lieu propice à l’implantation du puits ou du forage.</p>
              </div>
            </li>
            <li>
              <span className="demarche-step-num">3</span>
              <div>
                <h3>Discussions avec le village</h3>
                <p>
                  Dialogue avec le chef du village et les villageois pour qu’ils comprennent
                  l’investissement de l’association et des donateurs, mais surtout qu’ils seront
                  responsables de leur propre point d’eau, sans plus d’aide de personne.
                </p>
              </div>
            </li>
            <li>
              <span className="demarche-step-num">4</span>
              <div>
                <h3>Réalisation du chantier</h3>
                <p>Prise de décision, mise en place du chantier, réalisation du puits ou du forage.</p>
              </div>
            </li>
            <li>
              <span className="demarche-step-num">5</span>
              <div>
                <h3>Remise des clés</h3>
                <p>Remise officielle au village et adieux…</p>
              </div>
            </li>
          </ol>

          <h2 className="demarche-h2">Choisir, faute de pouvoir tout faire</h2>

          <p>
            Aujourd’hui, les demandes sont très nombreuses et nous ne pouvons assurer, loin de là,
            la totalité des besoins. C’est pourquoi, régulièrement entre <strong>octobre et
            décembre</strong>, nous étudions les demandes et faisons un choix malheureusement
            injuste, mais qui nous semble correspondre à un rapport moyen entre les besoins des
            populations les plus démunies et nos moyens financiers.
          </p>

          <div className="demarche-cta">
            <button type="button" className="link-button" onClick={() => navigate('historique')}>
              ← Lire notre histoire
            </button>
            <button type="button" className="link-button" onClick={() => navigate('projets')}>
              Voir les projets antérieurs →
            </button>
            <button type="button" className="link-button" onClick={() => navigate('home')}>
              Retour à l’accueil
            </button>
          </div>
        </div>
      </section>
    </article>
  );
}
